import { X } from 'lucide-react';

type HistoryHeaderProps = {
  onClose: () => void;
};

export const HistoryHeader = ({ onClose }: HistoryHeaderProps) => {
  return (
    <div className="px-6 py-4 border-b border-[#E5E7EB] flex items-center justify-between">
      <h3 className="font-termina text-lg font-semibold text-[#111827]">History</h3>
      <button
        type="button"
        onClick={onClose}
        className="text-[#9AA3B7] hover:text-[#6f778c] transition-colors"
        aria-label="Close history"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
};

